import React, { Component } from 'react';
import { Message, Grid, Label } from 'semantic-ui-react';
import RQLSearchInput from './RQLSearchInput.jsx';
import ColumnFilter from './ColumnFilter.jsx';
import Events from '../../util/eventEmitter.js';
import ActionDropdown from '../action_dropdown/ActionDropdown.jsx';
import EdgeStoreSearchModal from '../edge/EdgeStoreSearchModal.jsx';

export default class NodeRQLSearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: false,
      interaction: false, // Indicates if the user interacted with the component
      success: false,
      filter: props.filter || {},
      queryStatus: { result: 0, succeeded: false, applied: false },
      edgeModalIsOpen: false,
    };
    this.handleFetch = this.handleFetch.bind(this);
  }

  handleFetch(data) {
    const error =
      (
        data || {
          error:
            'Unknown Error: RPM found an problem trying to access the search service',
        }
      ).error || '';
    const result = data && data.data ? data.data.length : 0;

    this.setState((prevState) => ({
      error,
      queryStatus: {
        result: result,
        succeeded: !error,
        applied: !!prevState.filter.query,
      },
    }));
  }

  componentDidMount() {
    Events.on(this.props.fetchChannel, this.handleFetch);

    // submit query if received on mounting
    if (this.props.filter && this.props.filter.query) {
      this.submitEvent();
    }
  }

  componentWillUnmount() {
    Events.off(this.props.fetchChannel, this.handleFetch);
  }

  updateValue(newQuery) {
    this.setState((prevState) => ({
      interaction: true,
      queryStatus: { result: 0, succeeded: false, applied: false },
      filter: { ...prevState.filter, query: newQuery },
    })); // set state to indicate user interaction
  }

  submitEvent() {
    Events.emit(this.props.submitChannel);
  }

  onClear() {
    this.setState({ filter: {}, interaction: false });
    this.submitEvent();
  }

  warnCreation(data) {
    this.setState({ filter: data, interaction: false, success: true }, () =>
      setTimeout(() => this.setState({ success: false }), 5000),
    );
  }

  toggleEdgeModal() {
    this.setState((prevState) => ({
      edgeModalIsOpen: !prevState.edgeModalIsOpen,
    }));
  }

  renderLink() {
    const { links } = this.props;
    const { filter, queryStatus, interaction } = this.state;
    const hasQuery = !!filter.query;
    const validQuery =
      queryStatus.applied && queryStatus.result > 0 && queryStatus.succeeded;
    const exporterParams = `?filter=${encodeURIComponent(filter.query)}&filter_id=${(!interaction && filter.id) || ''}`;

    return (
      <ActionDropdown
        className='ActionsDropdown'
        direction='left'
      >
        {links.create_node && (
          <ActionDropdown.Item
            icon='plus'
            redirectOnClick={links.create_node}
            text='New Node'
          />
        )}
        {links.import_node && (
          <ActionDropdown.Item
            icon='upload'
            redirectOnClick={links.import_node}
            text='Import CSV'
          />
        )}
        {links.export_node && (
          <ActionDropdown.Tooltip
            content='A valid filter must applied to export Nodes.'
            hidden={validQuery || (hasQuery && !queryStatus.applied)}
          >
            <ActionDropdown.Item
              disabled={!hasQuery || (queryStatus.applied && !validQuery)}
              icon='download'
              redirectOnClick={
                validQuery ? `${links.export_node}${exporterParams}` : ''
              }
              text='Export CSV'
            >
              {hasQuery && !queryStatus.applied && (
                <ActionDropdown.Confirmation
                  customConfirmationHandler={() => this.submitEvent()}
                  msg='In order to export Nodes to CSV, a filter must be applied. \
                       Would you like to Apply and Search the entered filter?'
                  tip='Edits to filters will be applied only after clicking Search.'
                  title='The current filter has not been applied!'
                />
              )}
            </ActionDropdown.Item>
          </ActionDropdown.Tooltip>
        )}
        {links.batch_qr_codes && (
          <ActionDropdown.Item
            icon='qrcode'
            text='Batch QR Codes'
            onClick={() => this.toggleEdgeModal()}
          >
            <EdgeStoreSearchModal
              isOpen={this.state.edgeModalIsOpen}
              link={links.batch_qr_codes}
              onClose={(e) => {
                e.stopPropagation();
                this.toggleEdgeModal();
              }}
            />
          </ActionDropdown.Item>
        )}
      </ActionDropdown>
    );
  }

  renderTitle() {
    if (!this.props.title) {
      return;
    }

    return (
      <Grid.Row className='rql-header'>
        <h2 className='float-left'>{`${this.props.title} `}</h2>
      </Grid.Row>
    );
  }

  render() {
    return (
      <Grid className='RQLSearchGrid'>
        {this.renderTitle()}

        {Object.keys(this.props.links).length > 0 && (
          <Grid.Row className='RQLGridRow first'>
            <If condition={this.state.filter.id && this.state.filter.name}>
              <Grid.Column
                floated={'left'}
                textAlign={'left'}
                verticalAlign={'middle'}
                width={6}
              >
                <div className='FilterLabel'>
                  Applied Filter: <span>{this.state.filter.name}</span>
                  <If condition={this.state.interaction}>
                    <Label
                      horizontal
                      className='RQLSavedFilterEdited'
                    >
                      Edited
                    </Label>
                  </If>
                </div>
              </Grid.Column>
            </If>

            <Grid.Column
              floated={'right'}
              textAlign={'right'}
              verticalAlign={'middle'}
              width={6}
            >
              <ColumnFilter
                options={this.props.columnOptions.map((col) => {
                  return {
                    value: col.id,
                    label: col.name,
                  };
                })}
                onChange={(columns, headers) =>
                  Events.emit(this.props.updateChannel, columns, headers)
                }
              />
              {this.renderLink()}
            </Grid.Column>
          </Grid.Row>
        )}

        <Grid.Row className='RQLGridRow'>
          <RQLSearchInput
            canCreateFilter={this.props.canCreateFilter}
            customSyntax={this.props.customSyntax}
            error={this.state.error}
            filter={this.state.filter}
            querySucceeded={this.state.queryStatus.succeeded}
            onChange={this.updateValue.bind(this)}
            onClear={this.onClear.bind(this)}
            onSave={this.warnCreation.bind(this)}
            onSubmit={this.submitEvent.bind(this)}
          />
        </Grid.Row>
        <If condition={this.state.error}>
          <Grid.Row className='RQLGridRow last'>
            <Message
              negative
              className='RQLMessage'
            >
              <Message.Header>{this.state.error.split(':')[0]}</Message.Header>
              <p>
                {this.state.error.replace(
                  `${this.state.error.split(':')[0]}:`,
                  '',
                )}
              </p>
            </Message>
          </Grid.Row>
        </If>
        <Grid.Row
          className={
            this.state.success
              ? 'RQLGridRow last RQLFadeIn'
              : 'RQLGridRow last RQLFadeOut'
          }
        >
          <Message
            positive
            className='RQLMessage'
          >
            <p>
              Saved Filter &quot;{this.state.filter.name}&quot; was successfully
              {this.state.filter.created_at === this.state.filter.updated_at
                ? ' created'
                : ' updated'}
              .
            </p>
          </Message>
        </Grid.Row>
      </Grid>
    );
  }
}
